module.exports = __webpack_public_path__ + "static/media/plane.a391c416.jpg";